module.exports = __webpack_public_path__ + "img/text_kit.a77f25ad.svg";